const t = "paymentMethodButton_sIPle", e = "paymentMethodButton__title_hjslS", o = "paymentMethodButton__active_PPE7a", n = {
  paymentMethodButton: t,
  paymentMethodButton__title: e,
  paymentMethodButton__active: o
};
export {
  n as default,
  t as paymentMethodButton,
  o as paymentMethodButton__active,
  e as paymentMethodButton__title
};
//# sourceMappingURL=paymentMethod.module.scss.js.map
